// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Step3_wrapper__uMsXq","trial":"Step3_trial__Y4YP0","verify-name-checkbox":"Step3_verify-name-checkbox__Tb1wb"};